import { render } from "./ShoppingCart.vue?vue&type=template&id=188e8ff0"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/nakhekhalagh-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__